import { render } from "./TariffTerms.vue?vue&type=template&id=610ec11c"
const script = {}

import "./TariffTerms.vue?vue&type=style&index=0&id=610ec11c&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__